// Les forfaits, tels que le serveur les vend (platform-service/lib/plans.ts PLANS).
// Une copie, parce que le build de la console ne reçoit pas platform-service ; plans.test.ts
// la tient égale à l'original.
import type { Plan } from "../api";

export const LANDING_PLANS: readonly Plan[] = [
  { id: "H", price_eur: 5, price_eur_year: 50, vat: "excluded", apps: 2, credit_usd_per_month: 0, tokens_per_month: 0, gb: 4, legacy: false },
];
